import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { NotificationService } from './notification.service'
import { ExportReport } from '../models/Tree'

@Injectable()
export class TreeService {
	constructor(
		private http: HttpClient,
		private readonly notificationService: NotificationService
	) {}

	public exportReport(data: ExportReport) {
		const options: HttpHeaders = this.setHeader()

		const companyId = localStorage.getItem('companyId')

		this.http.post(`${PATH}/tree/report/${companyId}`, data, {
			headers: options
		}).subscribe(result => {
			this.notificationService.notify('Você receberá um aviso por email ao finalizarmos', 200)
			console.log(result)
		}, error => {
			this.notificationService.notify('Erro ao gerar relatório', 400)
			console.log(error)
		})
	}

	public getAppraisalReports(companyId: string, dateStart: number, dateEnd: number): Observable<Array<any>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/demand/reportArboreal/all/${companyId}/${dateStart}/${dateEnd}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getOperationReports(companyId: string, dateStart: number, dateEnd: number): Observable<Array<any>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/operationService/reportArboreal/all/${companyId}/${dateStart}/${dateEnd}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}
